import { FooterSectionProps } from "@/src/layout/footer/v1";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa6";

export const footerSectionData_en: FooterSectionProps = {
  about: {
    description:
      "Welcome to a world where you are the center. With a vast team of certified engineers and skilled professionals, we are your ultimate one-stop solution for an extensive range of IT services. From infrastructure design and implementation to software development and cloud solutions, we provide comprehensive and cutting-edge support to meet all your technology needs.",
    socialLinks: [
      {
        icon: <FaLinkedin />,
        href: "https://www.linkedin.com/company/smartoasisoffical/",
      },
      {
        icon: <FaFacebookF />,
        href: "https://www.facebook.com/smartoasis.offcial",
      },
      {
        icon: <FaInstagram />,
        href: "https://www.instagram.com/smartoasis.official",
      },
    ],
  },
  columnOne: {
    title: "Services",
    links: [
      {
        label: "IT Infrastructure Services",
        href: "/en/services?id=1",
        openNewTab: false,
      },
      {
        label: "Managed IT Services",
        href: "/en/services?id=2",
        openNewTab: false,
      },
      {
        label: "Cybersecurity Services",
        href: "/en/services?id=3",
        openNewTab: false,
      },
      {
        label: "Software Development",
        href: "/en/services?id=4",
        openNewTab: false,
      },
      {
        label: "Digital Transformation Services",
        href: "/en/services?id=5",
        openNewTab: false,
      },
      {
        label: "Networking and Communication",
        href: "/en/services?id=6",
        openNewTab: false,
      },
      {
        label: "Data Analytics and Business Intelligence",
        href: "/en/services?id=7",
        openNewTab: false,
      },
      {
        label: "Consulting and Advisory Services",
        href: "/en/services?id=8",
        openNewTab: false,
      },
      {
        label: "Training and Education",
        href: "/en/services?id=9",
        openNewTab: false,
      },
      {
        label: "Support and Maintenance Services",
        href: "/en/services?id=10",
        openNewTab: false,
      },
      {
        label: "E-Government Solutions",
        href: "/en/services?id=11",
        openNewTab: false,
      },
    ],
  },
  columnTwo: {
    title: "Address",
    location: "Airport Street , AUIB University",
    mails: ["Info@soc.iq"],
    phoneNumbers: ["(+964)785-0100-005"],
  },
  columnThree: {
    title: "Solutions",
    links: [
      {
        id: 1,
        label: "TELECOMMUNICATIONS",
        href: "/",
        openNewTab: false,
      },
      {
        id: 2,
        label: "DATA CENTER AND HOSTING",
        href: "/",
        openNewTab: false,
      },
      {
        id: 3,
        label: "SOFTWARE DEVELOPMENT & INTEGRATION",
        href: "/",
        openNewTab: false,
      },
      {
        id: 4,
        label: "CYBERSECURITY SOLUTIONS",
        href: "/",
        openNewTab: false,
      },
      {
        id: 5,
        label: "VAPT (VULNERABILITY ASSESSMENT AND PENETRATION TESTING)",
        href: "/",
        openNewTab: false,
      },
      {
        id: 6,
        label: "INSTRUMENTATION AND CONTROL (I & C)",
        href: "/",
        openNewTab: false,
      },
      {
        id: 7,
        label: "SECURITY SYSTEMS SOLUTIONS",
        href: "/",
        openNewTab: false,
      },
      {
        id: 8,
        label: "IOT (INTERNET OF THINGS)",
        href: "/",
        openNewTab: false,
      },
    ],
  },
  footerBottom: {
    copyrightText: "© Smart Oasis 2025 | All Rights Reserved",
  },
};
